var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame11712769182(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#048E7D",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#048E7D",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0013 20.396C23.9543 20.396 23.1055 21.2448 23.1055 22.2918C23.1055 23.3389 23.9543 24.1877 25.0013 24.1877C26.0483 24.1877 26.8971 23.3389 26.8971 22.2918C26.8971 21.2448 26.0483 20.396 25.0013 20.396ZM21.4805 22.2918C21.4805 20.3473 23.0568 18.771 25.0013 18.771C26.9458 18.771 28.5221 20.3473 28.5221 22.2918C28.5221 24.2363 26.9458 25.8127 25.0013 25.8127C23.0568 25.8127 21.4805 24.2363 21.4805 22.2918Z",
    fill: "#048E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2063 21.3863C31.2915 12.8498 18.7215 12.8408 16.7967 21.3758C16.2566 23.7837 16.9155 26.0484 18.1179 28.1105C19.325 30.1809 21.0425 31.9814 22.5131 33.4228C22.5134 33.4231 22.5137 33.4234 22.5141 33.4238L22.8221 33.7236C22.8229 33.7244 22.8236 33.7251 22.8244 33.7258C23.8671 34.7245 24.5093 35.0212 25.015 35.0154C25.5261 35.0095 26.176 34.6924 27.2263 33.6697L27.2278 33.6683C28.7117 32.2305 30.5037 30.4083 31.7787 28.2937C33.0486 26.1874 33.7622 23.8636 33.2063 21.3863ZM21.6932 34.8924L21.6338 34.8352L21.6328 34.8343C21.5487 34.7525 21.4632 34.6692 21.3767 34.5843C19.8908 33.1281 18.0381 31.2 16.7141 28.929C15.385 26.6496 14.5515 23.96 15.2112 21.0197C17.5172 10.7918 32.4979 10.8038 34.7919 21.0306C35.4708 24.0566 34.5685 26.8136 33.1702 29.1327C31.7773 31.4432 29.8492 33.3909 28.359 34.8348C27.2718 35.8934 26.2213 36.6266 25.0336 36.6403C23.8406 36.654 22.7857 35.9395 21.6978 34.897L21.6932 34.8924Z",
    fill: "#048E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11712769182);
export default __webpack_public_path__ + "static/media/Frame 1171276918 (2).3f2f8726f3cc5c28005ae801bd7d067c.svg";
export { ForwardRef as ReactComponent };